export default "__VITE_PUBLIC_ASSET__0d2ce834__"